import marketService from '@/services/amio/market.service'
import marketModule from '@/store/modules/market.module'
import botModule from '@/store/modules/bot.module'

export const MARKET_MODE = {
  EXISTING: 'existing',
  NEW: 'new'
}

export function createDefaultMarketForm(defaults = {}) {
  return {
    mode: MARKET_MODE.EXISTING,
    sourceMarketId: null,
    name: '',
    language: defaults.language || 'en',
    timezone: defaults.timezone || 'Europe/Prague'
  }
}

function getMarketIdsUsedInMultiBotGroup(multiBots = [], multiBotGroupId = null) {
  if (!multiBotGroupId) return new Set()

  const marketIds = new Set()
  multiBots.forEach(multiBot => {
    if (multiBot.primaryBot?.multi_bot_id !== multiBotGroupId) return
    const marketId = multiBot.primaryBot?.market_id
    if (marketId) marketIds.add(marketId)
  })
  return marketIds
}

export function getAvailableMarketOptions(multiBots = [], multiBotGroupId = null) {
  const marketIdsInCurrentGroup = getMarketIdsUsedInMultiBotGroup(multiBots, multiBotGroupId)
  return marketModule.getMarketList()
    .filter(market => !marketIdsInCurrentGroup.has(market.id))
    .map(market => ({
      value: market.id,
      text: market.name
    }))
}

export function isMarketFormValid(form, hasExistingMarketOptions) {
  if (hasExistingMarketOptions && form.mode === MARKET_MODE.EXISTING) {
    return !!form.sourceMarketId
  }
  return !!(form.name?.trim() && form.language && form.timezone)
}

export function getMarketFormLanguageTimezone(form) {
  if (form.mode === MARKET_MODE.EXISTING && form.sourceMarketId) {
    return {
      language: marketModule.getMarketList().find(market => market.id === form.sourceMarketId)?.language || form.language,
      timezone: botModule.getBotList().find(bot => bot.market_id === form.sourceMarketId)?.timezone || form.timezone
    }
  }

  return {
    language: form.language,
    timezone: form.timezone
  }
}

export async function resolveMarketId(form) {
  if (form.mode === MARKET_MODE.EXISTING && form.sourceMarketId) {
    const market = marketModule.getMarketList().find(market => market.id === form.sourceMarketId)
    return {
      marketId: form.sourceMarketId,
      marketName: market.name,
      timezone: botModule.getBotList().find(bot => bot.market_id === market.id)?.timezone || form.timezone,
      language: market.language
    }
  }

  const newMarketName = `${form.name?.trim()} - ${form.language.toUpperCase()}`
  const createdMarket = await marketService.create(form.language, newMarketName)
  return {
    marketId: createdMarket.id,
    marketName: newMarketName,
    timezone: form.timezone,
    language: form.language
  }
}
